import React from "react";
import StoryPage from "~/src/components/story/pages/StoryPage";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";

export default function StoryBySlugPage() {
  return (
    <NavbarLayout>
      <StoryPage />
    </NavbarLayout>
  );
}
